import WorkoutEditorModal from './WorkoutEditorModal';

export default WorkoutEditorModal;
